import './topology-view.css';
export default {
  "topologyContainer": "pf-topology-container",
  "topologyContent": "pf-topology-content"
};